<template>
    <div class="layout">
      <Header
        :is-menu-mini="isMenuMini"
        @mini-click="isMenuMini = !isMenuMini"
        @mobile-menu-click="isMobileMenuOpen = !isMobileMenuOpen"
      />
      <div class="layout-wrapper">
          <Menu :menu="menu" :is-menu-mini="isMenuMini" class="layout-wrapper-nav"/>
          <MobileMenu :menu="menu" v-model="isMobileMenuOpen" />
        <div class="layout-content">
          <div id="content" >
            <router-view />
          </div>
        </div>
      </div>

    </div>
</template>

<script>
/**
 * Корневой Vue компонент модуля Layout
 * @module Layout/Component/App
 * @requires Layout/Component/Menu
 * @requires Layout/Component/Header
 * @requires Layout/Store
 * @requires vuex
 * @vue-data {String} currentPage - текущая страница
 * @vue-data {UserRole} userRole - роль пользователя
 * @vue-data {Array.<String>} btnVisiblePathNames - Пути на которых видны кнопки middle секции
 * */

/**
 * @typedef {('admin')} UserRole
 * */

import Menu from 'Layout/components/Menu.vue'
import Header from 'Layout/components/Header.vue'
import store from 'Layout/store'
import menu1 from 'Images/icon/menu1.svg'
import { LocalStorage } from 'quasar'
import MobileMenu from 'Layout/components/MobileMenu'

export default {
  name: 'VueLayout',
  store,
  components: {
    Menu,
    Header,
    MobileMenu
  },
  data: () => ({
    menu: [
      {
        title: 'Главная',
        path: '/',
        icon: menu1
      },
      {
        title: 'Геосервис',
        path: '/geo',
        icon: menu1
      },
      {
        title: 'Заказы',
        path: '/orders',
        icon: menu1
      },
      {
        title: 'Сборщики',
        path: '/pickers',
        icon: menu1
      },
      {
        title: 'Регулярная доставка',
        path: '/regular-delivery',
        icon: menu1
      }
    ],
    /**
     * @type UserRole
     * */
    userRole: null,
    /**
     * Список путей на которых кнопки из middle секции должны быть видны
     * @type Array.<String>
     * */
    btnVisiblePathNames: [
      'sales'
    ],
    isMenuMini: false,
    isMobileMenuOpen: false
  }),
  created() {
    this.userRole = LocalStorage.getItem('userRole')
  }
}
</script>

<style lang="scss">
.layout {
  min-width: 320px;

  &-wrapper {
    height: calc(100vh - var(--header-height));
    display: flex;
    &-nav{
      max-width: 240px;
    }
  }

  &-content {
    width: 100%;
    overflow: auto;
  }
}

.layout-menu {
  width: var(--menu-width);
  flex-shrink: 0;
  flex-grow: 0;
  background-color: $color-white;
  height: calc(100vh - var(--header-height));
  transition: width ease 0.3s;

  &.layout-menu--mini {
    width: var(--menu-mini-width);
  }

  @media screen and (max-width: $breakpoint-sm-max) {
    display: none;
  }
}

.layout-menu-item {
  display: flex;
  height: 56px;
  align-items: center;
  color: $color-blue-2;
  cursor: pointer;
  width: var(--menu-width);
  text-decoration: none;

  &:hover,
  &.active {
    background-color: $color-light-grey-3;
    color: $color-primary;
    position: relative;

    path {
      fill: $color-primary
    }

    &::before {
      display: block;
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 3px;
      height: 100%;
      background-color: $color-primary;
    }
  }

  .layout-menu-item-icon {
    width: 24px;
    height: 24px;
    margin: 0 20px;
  }

  .layout-menu-item-title {
    font-family: Roboto, sans-serif;
    font-size: 16px;
  }
}
</style>
